import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingValue, CastingMode } from 'src/app/components/att-casting-view/att-casting-view.component';

export type DateRequirements = { dateOnly: boolean, timeOnly: boolean, dateTime: boolean }

@Injectable({
  providedIn: 'root'
})
export class DateQualifierService implements Qualifier {
  public static months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public static monthsFull = ['January', 'Feburary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  public static daysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  public static days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  public static supportedStats = ['count', 'first', 'last', 'max', 'min'];

  static FromString(value: string, format: CastingTypeFormat): Date {
    let month: number;
    let day: number;
    let year: number;
    let hour: number;
    let minute: number;
    let ampm: string;
    let parts: Array<string> = [];
    switch (format) {
      case 'date#03/04/05':
        parts = value.match(/(\d{2})\/(\d{2})\/(\d{2})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#04-Mar-45':
        parts = value.match(/(\d{2})\-([^\-]+)\-(\d+)/);
        if (parts === null) {
          return null;
        }
        day = Number(parts[1]);
        month = DateQualifierService.months.indexOf(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#13:30':
        parts = value.match(/(\d+):(\d+)( ([aApP][Mm]))?/)
        if (parts === null) {
          return null;
        }
        hour = Number(parts[1]);
        minute = Number(parts[2]);
        if (!!parts[3]) {
          if (parts[3] === 'PM') {
            if (hour !== 12) {
              hour += 12;
            }
          } else {
            if (hour === 12) {
              hour = 0;
            }
          }
        }
        break;
      case 'date#1:30 PM':
        parts = value.match(/(\d+):(\d+)( ([aApP][Mm]))?/);
        if (parts === null) {
          return null;
        }
        hour = Number(parts[1]);
        minute = Number(parts[2]);
        if (!parts[3]) {
          if (hour > 12) {
            hour -= 12;
            ampm = 'PM";'
          } else {
            ampm = 'AM';
          }
        } else {
          ampm = parts[3].trim();
        }
        break;
      case 'date#01:30 PM':
        parts = value.match(/(\d+):(\d+)( ([aApP][Mm]))?/);
        if (parts === null) {
          return null;
        }
        hour = Number(parts[1]);
        minute = Number(parts[2]);
        if (!parts[3]) {
          if (hour > 12) {
            hour -= 12;
            ampm = 'PM";'
          } else {
            ampm = 'AM';
          }
        } else {
          ampm = parts[3].trim();
        }
        break;
      case 'date#2345-03-04':
        parts = value.match(/(\d{4})-(\d{2})-(\d{2})/);
        if (parts === null) {
          return null;
        }
        year = Number(parts[1]);
        month = Number(parts[2]);
        day = Number(parts[3]);
        break;
      case 'date#3/4/2345':
        parts = value.match(/(\d+)\/(\d+)\/(\d{4})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#3/4/2345 13:30':
        parts = value.match(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d+)/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        break;
      case 'date#3/4/2345 1:30 PM':
        parts = value.match(/(\d{4})\/(\d{2})\/(\d{2}) (\d+):(\d+) [aApP][mM]/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        ampm = parts[6];
        break;
      case 'date#3/4/2345 01:30 PM':
        parts = value.match(/(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d+) [aApP][mM]/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        ampm = parts[6];
        break;


      case 'date#3/04/2345':
        parts = value.match(/(\d+)\/(\d{2})\/(\d{4})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#3/04/2345 13:30':
        parts = value.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d+)/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        break;
      case 'date#3/04/2345 1:30 PM':
        parts = value.match(/(\d+)\/(\d{2})\/(\d{4}) (\d+)\:(\d{2}) ([aApP][mM])/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        ampm = parts[6];
        break;
      case 'date#3/04/2345 01:30 PM':
        parts = value.match(/(\d+)\/(\d{2})\/(\d{4}) (\d{2})\:(\d{2}) ([aApP][mM])/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        ampm = parts[6];
        break;


      case 'date#03/04/2345':
        parts = value.match(/(\d{2})\/(\d{2})\/(\d{4})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#03/04/2345 13:30':
        parts = value.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2})\:(\d{2})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        break;
      case 'date#03/04/2345 1:30 PM':
        parts = value.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d+)\:(\d{2})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        break;
      case 'date#03/04/2345 01:30 PM':
        parts = value.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2})\:(\d{2})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        day = Number(parts[2]);
        year = Number(parts[3]);
        hour = Number(parts[4]);
        minute = Number(parts[5]);
        break;
      case 'date#3/2345':
        parts = value.match(/(\d+)\/(\d{4})/);
        if (parts === null) {
          return null;
        }
        month = Number(parts[1]);
        year = Number(parts[2]);
        break;
      case 'date#4-Mar-2345':
        parts = value.match(/(\d+)-([^-]+)-(\d{4})/);
        if (parts === null) {
          return null;
        }
        day = Number(parts[1]);
        month = DateQualifierService.months.indexOf(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#4-Mar-45':
        parts = value.match(/(\d+)-([^-]+)-(\d{4})/);
        if (parts === null) {
          return null;
        }
        day = Number(parts[1]);
        month = DateQualifierService.months.indexOf(parts[2]);
        year = Number(parts[3]);
        if (year < 50) {
          year += 2000;
        } else {
          year += 1900;
        }
        break;
      case 'date#Julian:62':
      case 'date#Julian:062':
        return DateQualifierService.FromJulianDate(Number(value), new Date());
      case 'date#Julian:2345062':
        {
          parts = value.match(/(\d{4})(\d{3})/);
          if (parts === null) {
            return null;
          }

          const targetDate = new Date();
          if (parts.length > 1) {
            targetDate.setUTCFullYear(Number(parts[1]))
          }
          return DateQualifierService.FromJulianDate(Number(parts[2]), targetDate);
        }
        break;
      case 'date#Julian:45062':
        {
          parts = value.match(/(\d{2})(\d{3})/);
          if (parts === null) {
            return null;
          }
          const targetDate = new Date();
          if (parts.length > 1) {
            if (targetDate.getUTCFullYear() < (2000 + Number(parts[1]))) {
              targetDate.setUTCFullYear(1900 + Number(parts[1]));
            } else {
              targetDate.setUTCFullYear(2000 + Number(parts[1]))
            }
          }
          return DateQualifierService.FromJulianDate(Number(parts[2]), targetDate);
        }
        break;
      case 'date#Mar-45':
      case 'date#Mar-2345':
        parts = value.match(/([\w+])-(\d+)/);
        if (parts === null) {
          return null;
        }
        month = Number(DateQualifierService.monthsFull.indexOf(parts[1]));
        year = Number(parts[3]);
        day = 1;
        break;
        break;
      case 'date#March 04, 2345':
        parts = value.match(/([\w+]) (\d+), (\d{4})/);
        if (parts === null) {
          return null;
        }
        month = Number(DateQualifierService.monthsFull.indexOf(parts[1]));
        day = Number(parts[2]);
        year = Number(parts[3]);
        break;
      case 'date#Tuesday, March 4, 2345':
        parts = value.match(/(\w+)[, ]+(\w+) (\d+)[, ]+(\d{4})/)
        if (parts === null) {
          return null;
        }
        month = Number(DateQualifierService.monthsFull.indexOf(parts[2]));
        day = Number(parts[3]);
        year = Number(parts[4]);
        break;
      case 'date#Tuesday, March 04, 2345':
        parts = value.match(/(\w+)[, ]+(\w+) (\d{2})[, ]+(\d{4})/)
        if (parts === null) {
          return null;
        }
        month = Number(DateQualifierService.monthsFull.indexOf(parts[2]));
        day = Number(parts[3]);
        year = Number(parts[4]);
        break;
    }
    const returnDate = new Date();
    if (!!year) {
      returnDate.setFullYear(year);
    }
    if (!!month) {
      returnDate.setMonth(month - 1);
    }
    if (!!day) {
      returnDate.setDate(day);
    }
    if (!!hour) {
      if (!!ampm) {
        if (ampm.toLowerCase() === 'pm') {
          if (hour < 12) {
            hour += 12;
          }
        }
      }
      returnDate.setHours(hour);
    }
    if (!!minute) {
      returnDate.setMinutes(minute);
    }
    return returnDate;
  }
  static ToString(value: Date, format: CastingTypeFormat): string {
    let month: string;
    let day: string;
    let dayName: string;
    let year: string;
    let time: string;
    switch (format) {
      case 'date#03/04/05':
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        return month + '/' + day + '/' + year;
      case 'date#04-Mar-45':
        month = DateQualifierService.GetMonth(value, 'Short');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, '2-digit');
        return day + '-' + month + '-' + year;
      case 'date#13:30':
        return DateQualifierService.GetTime(value, '24-hour', 2);
      case 'date#01:30 PM':
        return DateQualifierService.GetTime(value, '12-hour', 2);
      case 'date#1:30 PM':
        return DateQualifierService.GetTime(value, '12-hour', 0);

      case 'date#2345-03-04':
        year = DateQualifierService.GetYear(value, 'digits');
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, '2-digit');
        return year + '-' + month + '-' + day;
      case 'date#2345/03/04':
        year = DateQualifierService.GetYear(value, 'digits');
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, '2-digit');
        return year + '-' + month + '-' + day;


      case 'date#3/2345':
        month = DateQualifierService.GetMonth(value, 'digits');
        year = DateQualifierService.GetYear(value, 'digits');

        return month + '/' + year;
      case 'date#3/4/2345':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, 'digits');
        year = DateQualifierService.GetYear(value, 'digits');
        return month + '/' + day + '/' + year;
      case 'date#3/4/2345 13:30':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, 'digits');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '24-hour');
        return month + '/' + day + '/' + year + ' ' + time;
      case 'date#3/4/2345 01:30 PM':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, 'digits');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '12-hour');
        return month + '/' + day + '/' + year + ' ' + time;
      case 'date#3/4/2345 1:30 PM':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, 'digits');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '12-hour', 0);
        return month + '/' + day + '/' + year + ' ' + time;

      case 'date#3/04/2345':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, 'digits');
        year = DateQualifierService.GetYear(value, 'digits');
        return month + '/' + day + '/' + year;
      case 'date#3/04/2345 13:30':
        year = DateQualifierService.GetYear(value, 'digits');
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, 'digits');
        time = DateQualifierService.GetTime(value, '24-hour');
        return month + '/' + day + '/' + year + ' ' + time;
      case 'date#3/04/2345 01:30 PM':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '12-hour');
        return month + '/' + day + '/' + year + ' ' + time;
      case 'date#3/04/2345 1:30 PM':
        month = DateQualifierService.GetMonth(value, 'digits');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '12-hour', 0);
        return month + '/' + day + '/' + year + ' ' + time;

      case 'date#03/04/2345':
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        return month + '/' + day + '/' + year;
      case 'date#03/04/2345 13:30':
        year = DateQualifierService.GetYear(value, '2-digit');
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, 'digits');
        time = DateQualifierService.GetTime(value, '24-hour');
        return month + '/' + day + '/' + year + ' ' + time;
      case 'date#03/04/2345 01:30 PM':
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '12-hour');
        return month + '/' + day + '/' + year + ' ' + time;
      case 'date#03/04/2345 1:30 PM':
        month = DateQualifierService.GetMonth(value, '2-digit');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        time = DateQualifierService.GetTime(value, '12-hour', 0);
        return month + '/' + day + '/' + year + ' ' + time;


      case 'date#Mar-45':
        month = DateQualifierService.GetMonth(value, 'Short');
        year = DateQualifierService.GetYear(value, '2-digit');
        return month + '-' + year;
      case 'date#Mar-2345':
        month = DateQualifierService.GetMonth(value, 'Short');
        year = DateQualifierService.GetYear(value, 'digits');
        return month + '-' + year;
      case 'date#4-Mar-2345':
        day = DateQualifierService.GetDay(value, 'digits');
        month = DateQualifierService.GetMonth(value, 'Short');
        year = DateQualifierService.GetYear(value, 'digits');
        return day + '-' + month + '-' + year;
      case 'date#4-Mar-45':
        day = DateQualifierService.GetDay(value, 'digits');
        month = DateQualifierService.GetMonth(value, 'Short');
        year = DateQualifierService.GetYear(value, '2-digit');
        return day + '-' + month + '-' + year;
      case 'date#Julian:62':
        return ('' + DateQualifierService.JulianDate(value));
        return month;
      case 'date#Julian:062':
        return ('' + DateQualifierService.JulianDate(value)).padStart(3, '0');
      case 'date#Julian:2345062':
        return DateQualifierService.GetYear(value, 'digits') + ('' + DateQualifierService.JulianDate(value)).padStart(3, '0');
      case 'date#Julian:45062':
        return DateQualifierService.GetYear(value, '2-digit') + ('' + DateQualifierService.JulianDate(value)).padStart(3, '0');
      case 'date#March 04, 2345':
        month = DateQualifierService.GetMonth(value, 'full');
        day = DateQualifierService.GetDay(value, '2-digit');
        year = DateQualifierService.GetYear(value, 'digits');
        return month + ' ' + day + ', ' + year;
      case 'date#Tuesday, March 4, 2345':
        month = DateQualifierService.GetMonth(value, 'full');
        day = DateQualifierService.GetDay(value, '2-digit');
        dayName = DateQualifierService.GetDay(value, 'full');
        year = DateQualifierService.GetYear(value, 'digits');
        return dayName + ', ' + month + ' ' + day + ' ' + year;
    }
    return value.toISOString();
  }
  static GetMonth(value: Date, mode: '2-digit' | 'digits' | 'short' | 'SHORT' | 'Short' | 'full'): string {

    switch (mode) {
      case '2-digit':
        return ('' + (value.getUTCMonth() + 1)).padStart(2, '0');
      case 'digits':
        return '' + (value.getUTCMonth() + 1);
      case 'Short':
        return DateQualifierService.months[value.getUTCMonth()];
      case 'short':
        return DateQualifierService.months[value.getUTCMonth()].toLowerCase();
      case 'SHORT':
        return DateQualifierService.months[value.getUTCMonth()].toUpperCase();
      case 'full':
        return DateQualifierService.monthsFull[value.getUTCMonth()];
    }

  }
  static DBToDate(value: string): Date {
    const date = new Date(value);
    return date;
  }
  static DateToDB(value: Date): string {
    return value.toJSON().split('T').shift();
  }
  static GetDay(value: Date, mode: '2-digit' | 'digits' | 'short' | 'SHORT' | 'Short' | 'full'): string {
    switch (mode) {
      case '2-digit':
        return ('' + value.getDate()).padStart(2, '0');
      case 'digits':
        return '' + value.getDate();
      case 'Short':
        return DateQualifierService.days[value.getDay()];
      case 'short':
        return DateQualifierService.days[value.getDay()];
      case 'SHORT':
        return DateQualifierService.days[value.getDay()];
      case 'full':
        return DateQualifierService.daysFull[value.getDay()];
    }
  }
  static GetYear(value: Date, mode: '2-digit' | 'digits'): string {
    switch (mode) {
      case '2-digit':
        return ('' + value.getFullYear()).substr(-2);
      case 'digits':
        return '' + value.getFullYear();
    }
  }
  static GetTime(value: Date, mode: '24-hour' | '12-hour', pad: 0 | 2 = 2): string {
    if (value === null) {
      return '';
    }
    const hr = value.getHours()
    const minute = value.getMinutes();
    switch (mode) {
      case '24-hour':
        return ('' + hr).padStart(pad, '0') + ':' + ('' + minute).padStart(2, '0');
      case '12-hour':
        if (hr >= 12) {
          const hrAdj = hr - 12;
          return ('' + (hrAdj === 0 ? 12 : hrAdj)).padStart(pad, '0') + ':' + ('' + minute).padStart(2, '0') + ' PM';
        } else {

          return ('' + (hr === 0 ? 12 : hr)).padStart(pad, '0') + ':' + ('' + minute).padStart(2, '0') + ' AM';
        }

    }
  }
  static GetRequirements(format: string) {
    switch (format) {
      case 'date#03/04/05':
      case 'date#04-Mar-45':
      case 'date#2345-03-04':
      case 'date#3/2345':
      case 'date#03/2345':
      case 'date#3/4/2345':
      case 'date#3/04/2345':
      case 'date#03/04/2345':
      case 'date#4-Mar-2345':
      case 'date#4-Mar-45':
      case 'date#Julian:62':
      case 'date#Julian:062':
      case 'date#Julian:2345062':
      case 'date#Julian:45062':
      case 'date#Mar-45':
      case 'date#Mar-2345':
      case 'date#March 04, 2345':
      case 'date#Tuesday, March 4, 2345':
      default:
        return { dateOnly: true, timeOnly: false, dateTime: false };
      case 'date#13:30':
      case 'date#1:30 PM':
      case 'date#01:30 PM':
        return { dateOnly: false, timeOnly: true, dateTime: false };
      case 'date#3/4/2345 13:30':
      case 'date#3/4/2345 01:30 PM':
      case 'date#3/4/2345 1:30 PM':
      case 'date#3/04/2345 13:30':
      case 'date#3/04/2345 01:30 PM':
      case 'date#3/04/2345 1:30 PM':
      case 'date#03/04/2345 13:30':
      case 'date#03/04/2345 01:30 PM':
      case 'date#03/04/2345 1:30 PM':
        return { dateOnly: false, timeOnly: false, dateTime: true };
    }
  }
  public static JulianDateFromUnprojected(value: string) {
    return DateQualifierService.JulianDate(new Date(value));
  }
  public static JulianDate(value: Date): number {
    // based on https://stackoverflow.com/a/40975730/7403919
    // answer by user2501097
    new Date(value)
    return (Date.UTC(value.getFullYear(), value.getMonth(), value.getUTCDate()) - Date.UTC(value.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
  }
  public static FromJulianDate(julianDate: number, startDate?: Date) {
    // returns jdate in local time for the julian day for the year identified in startDate
    if (!startDate) {
      startDate = new Date();
    }
    const start = new Date(Number(startDate));
    start.setMonth(0);
    start.setHours(0, startDate.getTimezoneOffset(), 0, 0);
    start.setDate(0);
    return new Date(Number(start) + 86400000 * julianDate);

  }
  public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): string {
    if (!value) {
      return '';
    }
    if (!attribute.casting) {
      return '';
    }
    if (!attribute.casting[castingMode]) {
      return '';
    }
    const casting: CastingValue = attribute.casting[castingMode];

    switch (attribute.type) {
      case 'text':
      case 'string':
        if (casting.type !== 'time') {
          return value;
        }
      // tslint:disable-next-line: no-switch-case-fall-through
      default:
        const parts = value.split('-');
        const date = new Date();
        date.setFullYear(Number(parts[0]));
        date.setMonth(Number(parts[1])-1) // make month zero-based
        date.setDate(Number(parts[2]))
        return DateQualifierService.ToString(date, casting.format);
    }
  }
  public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
    if ([undefined, null].indexOf(val) > -1) {
      return '';
    }
    return DateQualifierService.GetDisplayValue(attribute, castingMode, val);

  }
  public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
    if ([null, undefined, ''].indexOf(value) > -1) {
      return '';
    }
    return DateQualifierService.FromString(value, attribute.casting[castingMode].format);
  }
  public static SupportsStat(statName): boolean {
    return DateQualifierService.supportedStats.indexOf(statName) > -1;
  }
  public static GetNumFormat(attribute: AttributeInfo, castingMode: CastingMode) {
    let castingValue: CastingValue = null;

    if (!!attribute.casting && !!attribute.casting[castingMode]) {
      castingValue = attribute.casting[castingMode];
    } else if (!!attribute.casting && !!attribute.casting.entry) {
      castingValue = attribute.casting.entry;
    } else {
      return 'yyyy-mm-dd';
    }

    switch (attribute.casting[castingMode].format) {
      case 'date#03/04/05':
        return 'mm/dd/yy';
      case 'date#04-Mar-45':
        return 'dd/mmm/yy';
      case 'date#2345-03-04':
        return 'yyyy-mm-dd';
      case 'date#2345/03/04':
        return 'yyyy/mm/dd';
      case 'date#3/2345':
        return 'm/yyyy';
      case 'date#03/2345':
        return 'mm/yyyy';
      case 'date#3/4/2345':
        return 'm/d/yyyy';
      case 'date#3/04/2345':
        return 'm/dd/yyyy';
      case 'date#03/04/2345':
        return 'mm/dd/yyyy';
      case 'date#4-Mar-2345':
        return 'd-mmm-yyyy';
      case 'date#4-Mar-45':
        return 'd-mmm-yyyy';
      case 'date#Julian:62':
        return '00';
      case 'date#Julian:062':
        return '000';
      case 'date#Julian:2345062':
        return '0000000';
      case 'date#Julian:45062':
        return '00000';
      case 'date#Mar-45':
        return 'mmm-yy';
      case 'date#Mar-2345':
        return 'mmm-yyyy';
      case 'date#March 04, 2345':
        return 'mmmm dd, yyyy';
      case 'date#Tuesday, March 4, 2345':
        return 'dddd, mmmm dd, yyyy';
      case 'date#13:30':
        return 'hh:mm';
      case 'date#1:30 PM':
        return 'h:mm AM/PM';
      case 'date#01:30 PM':
        return 'hh:mm AM/PM';
      case 'date#3/4/2345 13:30':
        return 'm/d/yyy hh:mm';
      case 'date#3/4/2345 01:30 PM':
        return 'm/d/yyyy hh:mm AM/PM';
      case 'date#3/4/2345 1:30 PM':
        return 'm/d/yyyy h:mm AM/PM';
      case 'date#3/04/2345 13:30':
        return 'm/d/yyyy hh:mm';
      case 'date#3/04/2345 01:30 PM':
        return 'm/dd/yyyy hh:mm AM/PM';
      case 'date#3/04/2345 1:30 PM':
        return 'm/dd/yyyy h:mm AM/PM';
      case 'date#03/04/2345 13:30':
        return 'mm/dd/yyyy hh:mm AM/PM';
      case 'date#03/04/2345 01:30 PM':
        return 'mm/dd/yyyy hh:mm AM/PM';
      case 'date#03/04/2345 1:30 PM':
        return 'mm/dd/yyyy h:mm AM/PM';

    }
    return '0.0';
  }
  constructor() { }
  /*public static GetXlsNum(attribute: AttributeInfo, castingMode: CastingMode, value: number) {
    let castingValue: CastingValue = null;

    if (!!attribute.casting && !!attribute.casting[castingMode]) {
      castingValue = attribute.casting[castingMode];
    } else if (!!attribute.casting && !!attribute.casting.entry) {
      castingValue = attribute.casting.entry;
    } else {
      return value;
    }
    switch (attribute.casting[castingMode].format) {
      case 'date#03/04/05':
      case 'date#04-Mar-45':
      case 'date#2345-03-04':
      case 'date#3/2345':
      case 'date#03/2345':
      case 'date#3/4/2345':
      case 'date#3/04/2345':
      case 'date#03/04/2345':
      case 'date#4-Mar-2345':
      case 'date#4-Mar-45':
      case 'date#Julian:62':
      case 'date#Julian:062':
      case 'date#Julian:2345062':
      case 'date#Julian:45062':
      case 'date#Mar-45':
      case 'date#Mar-2345':
      case 'date#March 04, 2345':
      case 'date#Tuesday, March 4, 2345':

      case 'date#13:30':
      case 'date#1:30 PM':
      case 'date#01:30 PM':

      case 'date#3/4/2345 13:30':
      case 'date#3/4/2345 01:30 PM':
      case 'date#3/4/2345 1:30 PM':
      case 'date#3/04/2345 13:30':
      case 'date#3/04/2345 01:30 PM':
      case 'date#3/04/2345 1:30 PM':
      case 'date#03/04/2345 13:30':
      case 'date#03/04/2345 01:30 PM':
      case 'date#03/04/2345 1:30 PM':
    }
  }
  */

}
